var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled, { spacing } from "@rentiohq/web-theme";
export var Wrap = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin: 0 0 ", ";\n  padding: 0;\n  &:last-child {\n    margin-bottom: 0;\n  }\n"], ["\n  margin: 0 0 ", ";\n  padding: 0;\n  &:last-child {\n    margin-bottom: 0;\n  }\n"])), spacing("tight"));
var templateObject_1;
